// extracted by mini-css-extract-plugin
module.exports = {"timing":"Timing_timing__TZTId","timing__icon":"Timing_timing__icon__9jvGE"};